import { Injectable } from '@angular/core';
import { AppConfiguration } from '@app/core/models';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigurationService {
  /** Get the application configuration (WIP) */
  getConfig(): Observable<AppConfiguration> {
    return of({
      pageTitle: 'Dura Vermeer Integration Portal',
      backendVersion: '1.0.0',
    });
  }
}
